/**
 * Contratação de plano dentro do CONTA (SC-11070).
 *
 * Qualquer tela abre o checkout disparando este evento; o Layout escuta e monta
 * o drawer uma vez só. Substitui o `window.open` para o link de contratação
 * externo, que criava o cadastro na conta de cobrança sem vínculo com a conta.
 */
export const SAAS_CHECKOUT_OPEN_EVENT = 'clientbase:saas-checkout-open'

/** Chaves aceitas pelo backend (Saas::SubscriptionPlans). */
export type SaasPlanKey =
  | 'start'
  | 'grow'
  | 'scale'
  | 'start_offer'
  | 'start_annual'
  | 'grow_annual'
  | 'scale_annual'

export type SaasCheckoutOpenDetail = {
  planKey: SaasPlanKey
  /** De onde veio o clique, para o tracking do funil. */
  source: string
}

export const openSaasCheckout = (planKey: SaasPlanKey, source: string) => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent<SaasCheckoutOpenDetail>(SAAS_CHECKOUT_OPEN_EVENT, {
      detail: { planKey, source }
    })
  )
}
